package com.tixforgigs.common.core.extensions

import com.tixforgigs.common.CommonBuildKonfig

object BuildKonfigUtil {

  val API_VERSION = CommonBuildKonfig.API_VERSION
  val CLIENT_VERSION = CommonBuildKonfig.CLIENT_VERSION

}